const ErrorMessages = {
    'product': {
        'no_vsan_sub_product': 'Select use case',
        'no_vsan_free_sub_product': 'Select use case',
        'no_vhci_sub_product': 'Select use case',
        'no_san_nas_sub_product': 'Select use case',
        'nvme_hosts': 'Select number of Initiator hosts',
    },
    'firstname': {
        'validate_required': 'First name is required',
        'two_latin_and_whitespace': 'Only Latin characters are allowed',
        'latin_and_whitespace': 'Only Latin characters are allowed',
        'firstname_lastname_match': 'First name and Last name cannot be identical',
        'fake_words': 'Please enter valid data',
        'repeat_symbols': 'Invalid name format',
    },
    'lastname': {
        'validate_required': 'Last name is required',
        'two_latin_and_whitespace': 'Only Latin characters are allowed',
        'latin_and_whitespace': 'Only Latin characters are allowed',
        'firstname_lastname_match': 'First name and Last name cannot be identical',
        'fake_words': 'Please enter valid data',
        'repeat_symbols': 'Invalid name format',
    },
    'email': {
        // 'validate_required': 'Corporate email is required',
        'validate_required': 'Email is required',
        'validate_valid_email': 'Invalid email format',
        'public_email': `Сompany-affiliated email address is required. If you do not have one, reach out to <a href="mailto:sales@starwind.com">sales@starwind.com</a> for help`,
    },
    'company': {
        'validate_required': 'Company is required',
        'two_latin_and_whitespace': 'Only Latin characters are allowed',
        'latin_and_whitespace': 'Only Latin characters are allowed',
        'repeat_symbols': 'Invalid name format',

    },
    'subject': {
        'validate_required': 'Subject title is required',
        'two_latin_and_whitespace': 'Only Latin characters are allowed',
        'latin_and_whitespace': 'Only Latin characters are allowed',
        'fake_words': 'Please enter valid data',
        'repeat_symbols': 'Invalid name format',
    },
    'existing_ticket_number': {
        'validate_required': 'Existing ticket number is required',
        'validate_numeric': 'Existing ticket number may only contain numeric characters',
    },
    'title': {
        'validate_required': 'Job title is required',
        'two_latin_and_whitespace': 'Only Latin characters are allowed',
        'latin_and_whitespace': 'Only Latin characters are allowed',
        'fake_words': 'Please enter valid data',
        'repeat_symbols': 'Invalid name format',
    },
    'phone': {
        'validate_required': 'Phone number is required',
        'not_valid_phone_format': 'Invalid phone number format',
        'validate_phone_number': 'Invalid phone number format',
        'phone_number': 'Invalid phone number format',
    },
    'country': {
        'validate_required': 'Country is required',
    },
    'state': {
        'no_country_state': 'State is required'
    },
    'captchaValue': {
        'validate_required': 'Captcha field is required',
        'custom_captcha_not_equal': 'Captcha is not valid',
    }
};

const errorPriority = function(error) {
    var res;
    // res = 0;
    switch (error) {
        case 'validate_required':
            res = 0;
            break;
        case 'fake_words':
            res = 4;
            break;
        case 'latin_and_whitespace':
            res = 5;
            break;
        default:
            res = 10;
    }
    return res;
}

const filterErrors = function(errors) {
    var key, obj;
    obj = {
        length: 0
    };
    for (key in errors) {
        if (key === 'length') {
            continue;
        }
        obj[key] = [errors[key][0]];
        obj.length += 1;
    }
    return obj;
}

const sortErrors = function (errors) {
    var key, obj, resObj, sortFunc;
    obj = {};

    for (key in errors) {
        if (key === 'length') {
            continue;
        }
        if (Array.isArray(errors[key])) {
            errors[key].forEach(function(element) {
                var priority;
                priority = errorPriority(element);
                if (obj[key] != null) {
                    return obj[key].push({
                        'rule': element,
                        'priority': priority
                    });
                } else {
                    return obj[key] = [
                        {
                            'rule': element,
                            'priority': priority
                        }
                    ];
                }
            });
        }
    }
    sortFunc = function(a, b) {
        var res;
        res = (+a.priority) - (+b.priority);
        return res;
    };
    for (key in obj) {
        obj[key].sort(sortFunc);
    }
    resObj = {
        length: 0
    };
    for (key in obj) {
        if (Array.isArray(errors[key])) {
            obj[key].forEach(function(element) {
                if (resObj[key] != null) {
                    resObj[key].push(element.rule);
                } else {
                    resObj[key] = [element.rule];
                }
                return resObj.length += 1;
            });
        }
    }
    return resObj;
}

export {sortErrors, filterErrors, ErrorMessages};
